import React from 'react'
import classNames from 'classnames';

class PageAnimator extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      active: false
    }

  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({active: true})
    }, 1)
  }

  render() {

    const { animateType = "fade" } = this.props;
    const { active } = this.state;

    var classes = classNames(
      'page-animate-' + animateType, {
        "PageAnimator": true,
        "active": active,
      });

    return (
      <div className={classes}>
        {this.props.children}
      </div>
    )
  }

}

export default PageAnimator;



// WEBPACK FOOTER //
// ./src/components/PageAnimator.js